export default __webpack_public_path__ + "89660a837dadd89f42148b393969118e.png";